import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';
import { Text, Separator, Button, Card } from '@cuemath/comps';
import { get as getPastPaymentsList } from 'actions/student-payment-link';
import { getAll as getAllCourses } from 'actions/course-list';
import { getAll as getAllAddons } from 'actions/addons';
import { openModal, closeModal } from 'actions/modal';
import PaymentInfo from '.././payment-link-modal/past-payment-view';
import { dateObjToEpoch, isValidPincodeIndia } from 'utils';
import { CURRENCY_OPTIONS } from 'constants/api';
import { getAll as getTeacherList } from 'actions/teacher-list';
import { TEACHERS_PER_PAGE } from 'constants/list';
import { COURSE_TYPE } from 'constants/student-courses';
import {
  Footer,
  Message,
  FormWrapper,
  ButtonWrapper,
  renderFormField,
  getOptions,
  HeaderHead,
  Field,
  Label,
  Asterisk,
  SelectInput,
  Input,
} from 'modules/form';

import {
  FIELD_TYPES,
  paymentDataFields,
  indiaBillingInfoFields,
  internationalBillingInfoField,
  addonDataFields,
  courseDataFields,
  getOnChangeMethod,
  getInputChangeMethod,
  MODAL_FORM,
  teacherStates,
  ERROR_MSG_FOR_TEACHER_LIST,
  MENU_CLOSE,
  updateFieldChoices,
} from 'constants/form';

const HeaderHeadWrapper = styled(HeaderHead)`
  padding: 10px 10px 10px 10px;
`;

const TextDescription = styled(Text)`
  font-weight: 800;
  margin-left: 100px;
  align-self: center;
  text-decoration: underline;
  width: 80%;
`;

const TextDescriptionParagraph = styled(Text)`
  margin-left: 100px;
  align-self: center;
  width: 80%;
`;

const CardWrapper = styled(Card)`
  margin-bottom: 12px;
  padding: 10px 10px 10px 10px;
  overflow: visible;
`;

const FieldWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 0px;
`;

const invoiceIdRegex = /\d|\w|_|-/g;
const INR = 'INR';
const billingFieldsStartingindex = 3;

class PaymentDataModal extends PureComponent {
  static defaultProps = {
    student: null,
  };

  static propTypes = {
    actions: PropTypes.shape({
      getPastPaymentsList: PropTypes.func.isRequired,
      getTeacherList: PropTypes.func.isRequired,
    }).isRequired,
    student: PropTypes.object.isRequired,
    getAllAddons: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      errorText: null,
      message: null,
      form: this.getFormDefaults(),
      formFields: this.getFormFields(),
      paymentLinkPost: store.post(),
      paymentInfoData: null,
      updateList: true,
      courses: [{ courseDataFields }],
      courseForm: [this.getCourseDefaults()],
      courseFields: this.getCourseFields(),
      courseOptions: [],
      courseChoices: [],
      addonCourseOptions: [],
      addonForm: [],
      allAddonOptions: [],
      page: 1,
      teachersData: null,
      teacherSearchKey: null,
    };

    [
      ...paymentDataFields,
      ...indiaBillingInfoFields,
      ...internationalBillingInfoField,
    ].forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  getCourseDefaults = () => {
    const courseDefaults = {};
    courseDataFields.forEach(field => {
      courseDefaults[field.name] = field.default;
    });

    return courseDefaults;
  };

  getFormDefaults = () => {
    const formDefaults = {};
    const { student } = this.props;

    paymentDataFields.forEach(field => {
      formDefaults[field.name] =
        !!student && student[field.param] ? student[field.param] : field.default;
    });
    return formDefaults;
  };

  getAddonFields = () => {
    return addonDataFields.map(field => {
      if (field.fieldType === FIELD_TYPES.SELECT)
        field.choices = getOptions({
          field: field.name,
          addonTypeOptions: [],
          addonNameOptions: [],
          addonCourseOptions: [],
        });
      return field;
    });
  };

  getCourseFields = () => {
    return courseDataFields.map(field => {
      if (field.fieldType === FIELD_TYPES.SELECT)
        field.choices = getOptions({ field: field.name, courseOptions: [] });
      return field;
    });
  };

  getFormFields = () => {
    return paymentDataFields.map(field => {
      if (field.fieldType === FIELD_TYPES.SELECT)
        field.choices = getOptions({ field: field.name, courseOptions: [] });
      return field;
    });
  };

  static getDerivedStateFromProps(props, state) {
    let getUpdatedAddonForm = (addonForm, field_name, choicesList) => {
      return addonForm.map(addon => {
        addon.addonFormFields.find(
          field => field.name === field_name,
        ).choices = choicesList;
        return addon;
      });
    };
    const { courseList, studentPaymentLink, teacherList, student, addonsList } = props;
    const {
      addonForm,
      courseFields,
      courseForm,
      form,
      formFields,
      page,
      teacherSearchKey,
    } = state;

    const listParams = { page, per_page: TEACHERS_PER_PAGE, search: teacherSearchKey };
    const newFormFields = [...paymentDataFields];

    const newState = {};
    newState.formFields = newFormFields;
    newState.courseFields = courseFields;
    newState.paymentInfoData = store.get(studentPaymentLink, student.id);

    let { upload_payment_currency: paymentCurrency } = form;
    paymentCurrency = paymentCurrency || '';

    if (paymentCurrency) {
      const fieldArr =
        paymentCurrency === INR ? indiaBillingInfoFields : internationalBillingInfoField;

      fieldArr.forEach((val, idx) => {
        const field = { ...val };
        const { fieldType, name } = field || {};

        if (fieldType === FIELD_TYPES.SELECT) {
          field.choices = getOptions({ field: name });
        }
        newFormFields.splice(billingFieldsStartingindex + idx, 0, field);
      });

      newState.formFields = newFormFields;
    }

    const courseListData = store.getAll(courseList);
    const addonsData = store.getAll(addonsList);
    let newAddonForm = addonForm;

    if (courseListData && courseListData.isLoaded) {
      newState.courseOptions = courseListData.data;
      const choicesList = getOptions({
        field: 'course',
        courseOptions: courseListData.data.filter(
          ({ course_type: courseType }) => courseType !== COURSE_TYPE.ELECTIVES,
        ),
      });
      newState.courseChoices = choicesList;
      newState.courseFields.find(field => field.name === 'id').choices = choicesList;
    }
    if (addonsData && addonsData.isLoaded) {
      newState.allAddonOptions = addonsData.data;
      newState.addonsTypeOptions = Object.keys(newState.allAddonOptions);
      const addonTypeChoicesList = getOptions({
        field: 'addon_type',
        addonTypeOptions: newState.addonsTypeOptions,
      });
      newAddonForm = getUpdatedAddonForm(
        newAddonForm,
        'addon_type',
        addonTypeChoicesList,
      );
    }

    let getCourseOptions = courseForm => {
      let courseOptions = [];
      for (let index = 0; index < courseForm.length; index++) {
        let course = courseForm[index].id;

        if (!!course) {
          courseOptions.push(course.value);
        }
      }
      return courseOptions;
    };

    let addonCourseOptions = getCourseOptions(courseForm);
    if (!!courseForm) {
      const addonCourseChoicesList = getOptions({
        field: 'addon_course',
        addonCourseOptions: addonCourseOptions,
      });
      newState.addonCourseChoices = addonCourseOptions;
      newAddonForm = getUpdatedAddonForm(
        newAddonForm,
        'addon_course',
        addonCourseChoicesList,
      );
    }
    newState.teachersData = store.getAll(teacherList, listParams);
    newState.addonForm = newAddonForm;

    return newState;
  }

  componentDidMount() {
    const { actions, student, studentPaymentLink } = this.props;
    const paymentInfoData = store.get(studentPaymentLink, student.id);
    actions.getAllCourses();
    actions.getAllAddons();
    if (student && !paymentInfoData) actions.getPastPaymentsList(student.id);
  }

  renderTeachersList = () => {
    const { teachersData, formFields } = this.state;
    const { data } = teachersData || {};

    const teachersDataAvailable = data && Array.isArray(data) && data.length > 0;

    if (teachersDataAvailable) {
      const choicesListOfTeachers = getOptions({
        field: 'teachers_list',
        teachersDataOptions: teachersData.data,
      });

      updateFieldChoices(['teacher_id'], formFields, choicesListOfTeachers);
    }
  };

  onChange = (key, value) => {
    const { form, errorText } = this.state;

    if (key === 'amount') {
      if (value < 0 || value > 999990) {
        this.setState({
          errorText: 'Please Add Valid Amount',
        });
        return;
      } else if (value.length > 6) return;
    }

    if (key === 'invoice_id') {
      if (value.trim().length > 26) {
        this.setState({
          errorText: 'Please Add Valid Invoice ID',
        });
        return;
      } else {
        value = value.trim();
      }
    }

    const newForm = { ...form };

    newForm[key] = value;

    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onToggle = event => {
    const { form, errorText } = this.state;
    const key = event.target.name;
    const value = event.target.checked;
    const stateChanges = {
      form: {
        ...form,
        [key]: value,
      },
    };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  onOptionChange = (key, value) => {
    const { form, errorText } = this.state;
    const newForm = { ...form };
    newForm[key] = value;
    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;
    this.setState(() => ({ ...stateChanges }));
  };

  areCoursesValid = () => {
    const { courseForm, courseFields } = this.state;

    let validCourses = courseForm && Array.isArray(courseForm) && courseForm.length > 0;
    if (!validCourses) {
      this.setState({ errorText: 'Please select a course', message: null });
      return false;
    }

    for (let i = 0; i < courseForm.length; i++) {
      let course = courseForm[i];
      for (let j = 0; j < courseFields.length; j++) {
        let courseField = courseFields[j];
        if (!course[courseField.name] && courseField.required) {
          this.setState({
            errorText: `Course Field: ${courseField.label} can not be empty`,
            message: null,
          });
          return false;
        }
      }
    }
    return true;
  };

  getCoursePayload = () => {
    const { courseForm, courseFields } = this.state;

    if (!this.areCoursesValid()) {
      return -1;
    }

    let courses = courseForm.map(course => {
      let dict = {};
      courseFields.forEach(courseField => {
        if (courseField.name === 'id') {
          dict[courseField.param] = course[courseField.name].value.id;
        } else if (courseField.fieldType === FIELD_TYPES.SELECT) {
          dict[courseField.param] = course[courseField.name].value;
        } else {
          dict[courseField.param] = course[courseField.name];
        }
      });
      dict['name'] = course['id'].value.name;
      return dict;
    });
    courses = courses.map(course => {
      course['no_of_classes'] =
        4 * parseInt(course['duration']) * parseInt(course['classes_per_week']);
      return course;
    });
    return courses;
  };

  getAddonsInfo = () => {
    const { addonForm } = this.state;

    let addonsInfo = addonForm.map(addon => {
      let dict = {};
      addon.addonFormFields.forEach(addonField => {
        if (addonField.name === 'addon_course') {
          dict[addonField.param] = addon[addonField.name].value.name;
        } else if (addonField.name === 'addon_type') {
          dict[addonField.param] = addon[addonField.name].value;
        } else if (addonField.name === 'addon_name') {
          dict[addonField.param] = addon[addonField.name].value.name;
        } else if (addonField.name === 'comments') {
          dict[addonField.param] = addon[addonField.name];
        } else {
          dict[addonField.param] = addon[addonField.name];
        }
      });
      return dict;
    });
    return addonsInfo;
  };

  getAddonPayload = () => {
    const { addonForm } = this.state;

    let addonPayload = [];

    for (let index = 0; index < addonForm.length; index++) {
      if (!addonForm[index].addon_course) {
        this.setState({
          errorText: 'Addon Course field can not be empty',
          message: null,
        });
        return -1;
      }
      if (!addonForm[index].addon_name) {
        this.setState({ errorText: 'Addon Name field can not be empty', message: null });
        return -1;
      }

      let course_id = addonForm[index].addon_course.value.id;
      let addon_id = addonForm[index].addon_name.value.id;
      let comments = addonForm[index].comments;
      let addon_data = { course_id: course_id, id: addon_id, comments: comments };

      addonPayload.push(addon_data);
    }

    if (addonPayload.length == 0) return null;

    return addonPayload;
  };

  billingDetailsValidated = () => {
    const { form } = this.state;

    const { upload_payment_currency: currency, indianState, country, pincode } =
      form || {};
    let errorText = '';

    if (!currency) {
      errorText = 'Please Choose a Currency Type';
    } else if (currency === INR) {
      if (!isValidPincodeIndia(pincode)) {
        errorText = 'Please Enter a valid Pincode';
      } else if (!indianState) errorText = 'Please Enter a valid state';
    } else if (!country) errorText = 'Please Enter a valid Country';

    if (errorText) {
      this.setState({ errorText });
      return false;
    }

    return true;
  };

  handlePostAction = () => {
    const { actions } = this.props;
    const { form, formFields } = this.state;

    const filteringTeacherData = () => {
      const { teachersData, form } = this.state;

      const { data } = teachersData || {};

      if (data) {
        const [selectedTeacher] = data.filter(({ id }) => id === form['teacher_id']);
        const { name = '', phone = '' } = selectedTeacher || {};
        const isTeacherSelected = name && phone && name.length && phone.length;

        return isTeacherSelected ? name + ' - ' + phone : null;
      }
      return null;
    };

    const data = {};

    formFields.forEach(({ name, param }) => {
      if (name === 'student_id') {
        data['student_id'] = form[name];
        data['id'] = form[name];
      } else if (name === 'paid_on') {
        data['paid_on'] = dateObjToEpoch(form[name]);
      } else data[param] = form[name];

      if (name === 'upload_payment_currency' && form[name] === INR)
        data['country'] = 'India';
    });

    data['courses'] = this.getCoursePayload();
    if (data['courses'] === -1) {
      return;
    }
    data['addons'] = this.getAddonPayload();
    if (data['addons'] === -1) {
      return;
    }

    data['addonsInfo'] = this.getAddonsInfo();

    const result = data['invoice_id'].match(invoiceIdRegex);

    if (result.length !== data['invoice_id'].length) {
      return this.setState({
        errorText: 'Please Add Valid Invoice ID',
      });
    }

    if (!this.billingDetailsValidated()) return;

    actions.openModal(
      MODAL_FORM.PAYMENT_CONFIRM_MODAL,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: '550px',
      },
      { paymentData: data, selectedTeacherDetails: filteringTeacherData() },
    );
  };

  onSubmit = event => {
    const {
      paymentLinkPost: { current },
    } = this.state;

    event.preventDefault();
    if (!(current && current.isCreating)) this.handlePostAction();
  };

  renderFormHeader = () => {
    return (
      <HeaderHeadWrapper>
        <Text size="xlarge" align="center">
          Upload Payment Data
        </Text>
      </HeaderHeadWrapper>
    );
  };

  renderShowPaymentsHeader = () => {
    return (
      <HeaderHeadWrapper>
        <Text size="xlarge" align="center">
          Past Payment Information
        </Text>
      </HeaderHeadWrapper>
    );
  };

  handleChange(i, e) {
    const { name, value } = e.target;
    let courseForm = [...this.state.courseForm];
    courseForm[i] = { ...courseForm[i], [name]: value };
    this.setState({ courseForm });
  }

  onTeacherSearch = (val, reason) => {
    const { action } = reason;
    const { actions } = this.props;
    const { errorText } = this.state;
    const { EXCLUDE_INACT_INTR } = teacherStates;

    const listParams = { page: 1, per_page: TEACHERS_PER_PAGE, search: val };
    const filterData = {
      page: 1,
      per_page: TEACHERS_PER_PAGE,
      state: EXCLUDE_INACT_INTR,
      search: val,
    };

    if (val && val.length <= 4 && action !== MENU_CLOSE) {
      this.setState({ errorText: ERROR_MSG_FOR_TEACHER_LIST });
      return;
    }
    if (errorText) {
      this.setState({ errorText: null });
    }

    if (action !== MENU_CLOSE || val.length !== 0) {
      this.setState({ teacherSearchKey: val }, () => {
        actions.getTeacherList(listParams, filterData);
      });
    }
  };

  handleAddonOptionChange(name, index, choice) {
    let stateChanges = {};
    let addonForm = [...this.state.addonForm];

    if (name == 'addon_type' && choice != addonForm[index][name] && choice) {
      addonForm[index].addon_name = null;
      const { allAddonOptions } = this.state;

      let addon_type = choice.value;
      const addonNameChoicesList = getOptions({
        field: 'addon_name',
        addonNameOptions: allAddonOptions[addon_type],
      });

      addonForm[index].addonFormFields.find(
        field => field.name === 'addon_name',
      ).choices = addonNameChoicesList;
      // addonForm[index].addon_name.choices = addonNameChoicesList;
    }
    addonForm[index] = { ...addonForm[index], [name]: choice };

    stateChanges.addonForm = addonForm;
    this.setState({ ...stateChanges });
  }

  handleCourseOptionChange(name, index, choice) {
    let stateChanges = {};
    let courseForm = [...this.state.courseForm];
    let addonForm = [...this.state.addonForm];

    if (name == 'id' && choice != courseForm[index][name] && choice) {
      addonForm = addonForm.map(addon => {
        addon.addonFormFields.find(field => field.name === 'addon_course').choices = null;
        addon.addon_course = null;
        return addon;
      });
    }

    courseForm[index] = { ...courseForm[index], [name]: choice };

    stateChanges.addonForm = addonForm;
    stateChanges.courseForm = courseForm;
    this.setState({ ...stateChanges });
  }

  getAddonDefaults = () => {
    const AddonDefaults = {};
    addonDataFields.forEach(field => {
      AddonDefaults[field.name] = field.default;
    });
    AddonDefaults.addonFormFields = JSON.parse(JSON.stringify(this.getAddonFields()));
    return AddonDefaults;
  };

  addAddonClick() {
    let newAddon = this.getAddonDefaults();
    this.setState(prevState => ({
      addonForm: [...prevState.addonForm, newAddon],
    }));
  }

  removeAddonClick(i) {
    let addonForm = [...this.state.addonForm];
    addonForm.splice(i, 1);
    this.setState({ addonForm: addonForm });
  }

  addCourseClick() {
    let newCourse = JSON.parse(JSON.stringify(this.getCourseDefaults()));
    this.setState(prevState => ({
      courseForm: [...prevState.courseForm, newCourse],
    }));
  }

  removeCourseClick(i) {
    let courseForm = [...this.state.courseForm];
    courseForm.splice(i, 1);
    this.setState({ courseForm });
  }

  renderAddonSelectField(addon, index, field) {
    const choiceList = addon.addonFormFields.find(
      formField => formField.name === field.name,
    ).choices;
    return (
      <Field key={field.name + index}>
        <Label profileView={field.profileView}>
          {field.label}
          {field.required ? <Asterisk>*</Asterisk> : null}
        </Label>
        <SelectInput
          required={field.required}
          name={field.name}
          value={addon[field.name]}
          onChange={this.handleAddonOptionChange.bind(this, field.name, index)}
          isSearchable
          isDisabled={field.disabled}
          isMulti={!!field.multiple}
          options={choiceList}
        />
      </Field>
    );
  }

  renderCourseSelectField(course, index, field) {
    const {
      name,
      label,
      default: defaultValue,
      required,
      disabled,
      multiple,
      choices,
      profileView,
    } = field || {};
    return (
      <Field key={name + index}>
        <Label profileView={profileView}>
          {label}
          {required ? <Asterisk>*</Asterisk> : null}
        </Label>
        <SelectInput
          required={required}
          name={name}
          value={course[name]}
          defaultValue={defaultValue}
          onChange={this.handleCourseOptionChange.bind(this, name, index)}
          isSearchable
          isDisabled={disabled}
          isMulti={!!multiple}
          options={choices}
        />
      </Field>
    );
  }

  handleAddonInputChange(key, i, value) {
    let addonForm = [...this.state.addonForm];
    addonForm[i] = { ...addonForm[i], [key]: value };
    this.setState({ addonForm: addonForm });
  }

  renderAddonsInputField(addon, index, field) {
    return (
      <Field key={field.name + index}>
        <Label profileView={field.profileView}>
          {field.label}
          {field.required ? <Asterisk>*</Asterisk> : null}
        </Label>
        <Input
          style={{ width: '210px' }}
          name={field.name}
          placeholder={field.placeholder}
          type={field.type}
          required={field.required}
          value={addon[field.name]}
          onChange={this.handleAddonInputChange.bind(this, field.name, index)}
          disabled={field.disabled}
          profileView={field.profileView || null}
          display={field.display || null}
          maxLength={field.maxlength || null}
        />
      </Field>
    );
  }

  renderAddonFormField(addon, index, field) {
    switch (field.fieldType) {
      case FIELD_TYPES.INPUT:
        return this.renderAddonsInputField(addon, index, field);
      case FIELD_TYPES.SELECT:
        return this.renderAddonSelectField(addon, index, field);
      default:
        return null;
    }
  }

  renderCourseFormField(course, index, field) {
    switch (field.fieldType) {
      case FIELD_TYPES.INPUT:
        return null; //this.renderCourseInputField(course, index, field);
      case FIELD_TYPES.SELECT:
        return this.renderCourseSelectField(course, index, field);
      default:
        return null;
    }
  }

  renderAddons() {
    const { addonForm } = this.state;
    return addonForm.map((addon, index) => (
      <CardWrapper>
        <FieldWrapper>
          {addonDataFields.map(field => {
            const disabled = field.disabled || !field.editable;
            const required = field.required;
            const placeholder = disabled ? '' : field.label;

            return this.renderAddonFormField(addon, index, {
              ...field,
              value: addonForm[index][field.name],
              required,
              disabled,
              placeholder,
            });
          })}
          <Button
            type="button"
            label="Remove Addon"
            onClick={this.removeAddonClick.bind(this, index)}
          />
        </FieldWrapper>
      </CardWrapper>
    ));
  }

  renderCourses() {
    const { courseForm } = this.state;
    return courseForm.map((course, index) => (
      <CardWrapper>
        <FieldWrapper>
          {courseDataFields.map(field => {
            const disabled = field.disabled || !field.editable;
            const required = field.required;
            const placeholder = disabled ? '' : field.label;

            return this.renderCourseFormField(course, index, {
              ...field,
              value: courseForm[index][field.name],
              required,
              disabled,
              placeholder,
            });
          })}
          <Button
            type="button"
            label="Remove course"
            onClick={this.removeCourseClick.bind(this, index)}
          />
        </FieldWrapper>
      </CardWrapper>
    ));
  }

  renderFormFields = () => {
    const { formFields, form } = this.state;
    return (
      <React.Fragment>
        <FieldWrapper>
          {formFields.map(field => {
            const disabled = field.disabled || !field.editable;
            const required = field.required;
            const placeholder = disabled ? '' : field.label;

            return renderFormField({
              ...field,
              value: form[field.name],
              onChange: this[getInputChangeMethod(field)],
              onInputChange: this.onTeacherSearch,
              required,
              disabled,
              placeholder,
            });
          })}
        </FieldWrapper>
        <Separator height={20} transparent />
        <TextDescription weight="semibold">
          Please note the format for various payment method
        </TextDescription>
        <TextDescriptionParagraph>
          <Separator height={20} transparent />
          RazorPay (Invoice Id) : inv_ErsT7YS3gYYE5r
          <Separator height={10} transparent />
          Paypal (Invoice Id): INV2-BQ7V-EQTK-CGWU-P53S
          <Separator height={10} transparent />
          Zest (Load Id): 936950C50A34
          <Separator height={10} transparent />
          Bank transfer (Transaction Id) : As shared by the bank
        </TextDescriptionParagraph>
      </React.Fragment>
    );
  };

  renderPaymentInfoview = () => {
    const { paymentInfoData } = this.state;
    if (paymentInfoData && paymentInfoData.isLoaded)
      return <PaymentInfo paymentInfo={!!paymentInfoData ? paymentInfoData.data : []} />;
  };

  renderFormFooter = () => {
    return (
      <Footer>
        <ButtonWrapper flex-direction="column">
          <Button label="save" />
        </ButtonWrapper>
      </Footer>
    );
  };

  render() {
    const { errorText, message, courseForm, courses } = this.state;

    return (
      <form onSubmit={this.onSubmit}>
        <FormWrapper>
          {this.renderTeachersList()}
          {this.renderFormHeader()}
          {message && <Message>{message}</Message>}
          <Separator transparent height="25" />
          {this.renderCourses()}
          <Separator transparent height="25" />
          <Button
            type="button"
            label="Add Course"
            onClick={this.addCourseClick.bind(this)}
          />

          <Separator transparent height="25" />
          {this.renderAddons()}
          <Separator transparent height="25" />
          <Button
            type="button"
            label="Add Addons"
            onClick={this.addAddonClick.bind(this)}
          />
          <Separator transparent height="25" />

          {this.renderFormFields()}
          {errorText && <Message error={true}>{errorText}</Message>}
          <Separator transparent height="30" />
          {this.renderFormFooter()}
          <Separator transparent height="25" />
          {this.renderShowPaymentsHeader()}
          <Separator transparent height="25" />
          {this.renderPaymentInfoview()}
          <Separator transparent height="25" />
        </FormWrapper>
      </form>
    );
  }
}

export default connect(
  ({ studentPaymentLink, configs, courseList, addonsList, teacherList }) => ({
    studentPaymentLink,
    currencyOptions: store.get(configs, CURRENCY_OPTIONS)?.data,
    courseList,
    addonsList,
    teacherList,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getAllCourses,
        getAllAddons,
        getPastPaymentsList,
        openModal,
        closeModal,
        getTeacherList,
      },
      dispatch,
    ),
  }),
)(PaymentDataModal);
